import './componentLoader'
import './css/main.css'
import './js/main.js'

import packageInformation from '@/../package'

console.info(
  '%c ⚑ sani%ctas DOTCOM',
  'font-weight:bold;color:#00765A;',
  'font-weight:bold;color:#5BAC26;',
  `v${packageInformation.version}`,
)
